export default {
    'categories.activities': 'Aktiviteetit',
    'categories.animals-nature': 'Eläimet & luonto',
    'categories.custom': 'Mukautettu',
    'categories.flags': 'Liput',
    'categories.food-drink': 'Ruoka & juoma',
    'categories.objects': 'Esineet',
    'categories.people-body': 'Ihmiset & keho',
    'categories.recents': 'Viimeksi käytetty',
    'categories.smileys-emotion': 'Hymiöt & tunne',
    'categories.symbols': 'Symbolit',
    'categories.travel-places': 'Matkustus & paikat',
    'error.load': 'Emojien lataaminen epäonnistui',
    'recents.clear': 'Tyhjennä viimeksi käytetyt emojit',
    'recents.none': 'Et ole valinnut vielä emojia.',
    'retry': 'Kokeile uudestaan',
    'search.clear': 'Tyhjennä haku',
    'search.error': 'Emojien etsiminen epäonnistui',
    'search.notFound': 'Emojia ei löytynyt',
    'search': 'Etsi emojia...'
  };
  